(ns client-portal.client.voice-insights.tags.data
  (:require [client-portal.client.voice-insights.data :as vi.d]
            [client-portal.client.concepts.data :as concepts.d]
            [client-portal.client.voice-insights.tag-data :refer [remove-internal-tags]]
            [shared.core.reactive :as re]
            [shared.core.util :as util]))

(def root-path [:voice-insights :tags])
(def by-concept-id-path (conj root-path :by-concept-id))
(def ces-score-tag-name "crew-ces-score")

(defn all-tags [tags-data]
  (-> (concat (get-in tags-data [:tags :utterance])
              (get-in tags-data [:tags :conversation])
              (get-in tags-data [:tags :post-processors]))
      (remove-internal-tags)))

(defn tags->name-value-pairs [tags]
  (mapcat (fn [tag]
            (mapv (fn [v] {:name (:name tag) :value (:value v)})
                  (:values tag)))
          tags))

(defn child->values [enums {:keys [enum enum-ref]}]
  (cond
    (not-empty enum) enum
    enum-ref (get enums (keyword enum-ref))
    :else nil))

(defn tag-children->options [enums children]
  (mapcat (fn [child]
            (mapv (fn [value] {:name (:name child) :value value})
                  (child->values enums child)))
          children))

(defn current-tags-data [db]
  (when-let [concept-id (concepts.d/current-concept-id db)]
    (get-in db (conj by-concept-id-path concept-id))))

(defn current-all-tags [db]
  (some-> (util/when-not-loading (current-tags-data db)) (all-tags)))

(defn current-tags-list-set [db]
  (some->> (current-all-tags db)
           (tags->name-value-pairs)
           (into #{})))

(defn current-tag-names-list-set [db]
  (some->> (current-all-tags db)
           (map :name)
           (into #{})))

(re/reg-auth0-loader
  :vi-tags/load-list
  (fn [[concept-id]]
    (conj by-concept-id-path concept-id))
  (fn [_ concept-id]
    {:method :post
     :url "/api/vi/tags/list"
     :json-params {:concept-id concept-id}})
  :transf (fn [resp]
            (or (some-> resp :body (util/->kebab-case-keywords))
                {}))
  :error-transf (fn [] {})
  :quiet-fail? true)

(re/reg-sub
  :vi-tags/list-by-current-concept-id-
  (fn [db]
    (let [concept-id (concepts.d/current-concept-id db)
          v (current-tags-data db)]
      (if (and concept-id (nil? v))
        (re/dispatch-load [:vi-tags/load-list concept-id])
        v))))

(re/reg-sub
  :vi-tags/set-by-current-concept-id-
  :<- [:vi-tags/list-by-current-concept-id-]
  (fn [tags-data]
    (or (some->> (util/when-not-loading tags-data)
                 (all-tags)
                 (tags->name-value-pairs)
                 (into #{}))
        #{})))

(re/reg-sub
  :vi-tags/names-set-by-current-concept-id-
  :<- [:vi-tags/list-by-current-concept-id-]
  (fn [tags-data]
    (or (some->> (util/when-not-loading tags-data)
                 (all-tags)
                 (map :name)
                 (into #{}))
        #{})))

(re/reg-sub
  :vi-tags/has-some?-
  :<- [:vi-tags/set-by-current-concept-id-]
  (fn [tags [some-tags]]
    (some #(contains? tags %) some-tags)))

(re/reg-sub
  :vi-tags/has-every?-
  :<- [:vi-tags/set-by-current-concept-id-]
  (fn [tags [every-tags]]
    (every? #(contains? tags %) every-tags)))

(re/reg-sub
  :vi-tags/has-some-name?-
  :<- [:vi-tags/names-set-by-current-concept-id-]
  (fn [tags [some-tag-names]]
    (some #(contains? tags %) some-tag-names)))

(re/reg-sub
  :vi-tags/has-every-name?-
  :<- [:vi-tags/names-set-by-current-concept-id-]
  (fn [tags [every-tag-names]]
    (every? #(contains? tags %) every-tag-names)))

(defn find-tag-by-name [tag-name tags]
  (some->> (util/when-not-loading tags)
           (filter #(= (some-> (:name %) (util/->kebab-case-string)) tag-name))
           (first)))

(defn find-ces-score-tag [tags]
  (find-tag-by-name ces-score-tag-name tags))
